export default "__VITE_ASSET__rJxLRgbW__"